<container-element [ngSwitch]="iconType">
  <ng-container *ngSwitchCase="'ng-zorro'">
    <span class="purple-sales-button-icon {{iconPosition}} {{noMargin?'no-margin':''}}" nz-icon 
    [nzType]="iconName" nzTheme="outline"></span>
  </ng-container>
  <ng-container *ngSwitchCase="'custom'">
    <span class="purple-sales-button-icon {{iconPosition}} {{iconName}} {{noMargin?'no-margin':''}}"></span>
  </ng-container>
</container-element>